/**
 * Главный модуль отладочных функций для AMO полей
 * Импортирует и экспортирует функции из специализированных модулей
 */


import { 
    baseDebugFunction,
    debugStateInfo,
    debugHTMLInfo,
    debugFieldInfo
} from './amoFieldsDebugCore.js';


import { 
    debugAmoField,
    debugMultiselectState,
    debugMultiselectHTML
} from './amoFieldsDebugAnalysis.js';


import { 
    testMultiselectSync,
    testClearMultiselect
} from './amoFieldsDebugTests.js';


export {
    baseDebugFunction,
    debugStateInfo,
    debugHTMLInfo,
    debugFieldInfo,
    debugAmoField,
    debugMultiselectState,
    debugMultiselectHTML,
    testMultiselectSync,
    testClearMultiselect
};


if (typeof window !== 'undefined') {
    window.debugMultiselectState = debugMultiselectState;
    window.debugAmoField = debugAmoField;
    window.debugMultiselectHTML = debugMultiselectHTML;
    window.testMultiselectSync = testMultiselectSync;
    window.testClearMultiselect = testClearMultiselect;
} 